import { i18n } from "@/locales/setup.js"

/** This function helps to resolve API errros
 * Because there are cases when our API returns different response
 * it usually doesn't return Query type but special status object
 * we have to check for errors in this wrapper
 * It doesn't trigger any error displaying, this has to be handled on component level
 * @param resolutionType String
 * @param res - object directly returned from the API
 * @param resKey String - key to check in res object, e.g. res.data.createInternal "createInternal" is the resKey here
 * @returns Promise - Will return promise with object that if all good includes { data: res.data}, if errors includes {errors:[...]}
 */
export default ({ resolutionType = "queryWithList", res, resKey }) => {
	// 1: Handle authorization errors
	if (
		res.errors &&
		res.errors.find(
			item => item.extensions && item.extensions.code === "authorization"
		)
	) {
		return Promise.resolve(errorsFactory({ code: "authorization" }))
	}

	// 2: Handle API errors
	// Normal resolution with list, used for most of the queries
	if (resolutionType === "queryWithList") {
		if (res && res.data && res.data[resKey] && res.data[resKey].list)
			return Promise.resolve({ data: res.data })
		else return Promise.resolve(errorsFactory({ code: "general" }))
	}

	// Normal resolution without list, used for queries
	if (resolutionType === "queryWithoutList") {
		if (res && res.data && res.data[resKey])
			return Promise.resolve({ data: res.data })
		else return Promise.resolve(errorsFactory({ code: "general" }))
	}

	if (resolutionType === "mutationWithStatus") {
		if (res && res.data && res.data[resKey]) {
			if (res.data[resKey].status === "success")
				return Promise.resolve({ data: res.data })
			else
				return Promise.resolve({
					errors: res.data[resKey].errors
						? res.data[resKey].errors
						: errorsFactory({ code: "general" })
				})
		} else {
			// Resolve promise that includes errors array to signify that there were errors
			// outside of createdStatus. Show general error to user
			return Promise.resolve(errorsFactory({ code: "general" }))
		}
	}

	if (resolutionType === "mutationWithoutStatus") {
		if (res && res.data && res.data[resKey])
			return Promise.resolve({ data: res.data })
		// Resolve promise that includes errors array to signify that there were errors
		// outside of createdStatus
		// In this case, if there are errors in graphql, we shoul pass it up to client as there are some messages to show to clients
		else
			return Promise.resolve(
				res.errors && res.errors[0]
					? { errors: [res.errors[0].message] }
					: errorsFactory({ code: "general" })
			)
	}
}

/**
 * Errors factory generates error messages in proper language
 * @param code - any code that can be find in localization.errors
 * @returns Object where property errors is an Array of error messages
 */
const errorsFactory = ({
	code = "general",
	locale = window.localStorage["covergo-locale"] || "en-US"
}) => ({
	errors: [i18n.messages[locale].errors[code]]
})
